import React from "react";
import productsData from "../../data/shadylane.json";
import ProductRangeLayout from "../../components/ProductRangeLayout";

function ShadyLane() {
	return (
		<ProductRangeLayout
			sectionTitle="Durable Ag Curtain Systems"
			sectionSubtitle="Low Maintenance Ag Curtains Designed and Manufactured"
			sectionBody="We design high-quality, weather-resistant ag curtain systems utilizing aluminum, stainless steel, and galvanized hardware components ensuring your systems function for years to come. To ensure a 100% top-quality product, we have the machinery and expertise to heat-weld all of our ag curtains right at our warehouse in Bird-in-Hand, PA. With our machines, we can fully customize your ag curtains to fit your needs! Contact us today!"
			products={productsData}
		/>
	);
}

export default ShadyLane;
